module.exports = __webpack_public_path__ + "static/media/driver-logo.89b50861.png";